import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MultiSelectFilter from "./MultiSelectFilter/MultiSelectFilter";
import PropTypes from "prop-types";
import { fetchGeneralTasksIDs } from "../../../actions/GeneralTasks/generalTasks";

const GeneralTaskIDMultiSelectFilter = ({
  actions: { fetchList },
  list,
  isFetching,
  ...extraProps
}) => {
  useEffect(() => {
    fetchList({ unpaged: true });
  }, [fetchList]);

  const options = useMemo(
    () =>
      list.map(item => ({
        key: item,
        text: `GT-${item}`,
        value: item
      })),
    [list]
  );

  return (
    <MultiSelectFilter
      options={options}
      numbers={true}
      loading={isFetching}
      {...extraProps}
    />
  );
};

const mapStateToProps = ({
  generalTasks: {
    taskIDs: { content, isFetching }
  }
}) => {
  return {
    list: content,
    isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchList: fetchGeneralTasksIDs }, dispatch)
});

GeneralTaskIDMultiSelectFilter.propTypes = {
  isFetching: PropTypes.bool,
  list: PropTypes.array,
  actions: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralTaskIDMultiSelectFilter);
